import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import InputField from "components/form/InputField";
import SelectField from "components/form/SelectField";
import TextAreaField from "components/form/TextAreaField";
import DateField from "components/form/DateField";
import FormActionButtons from "components/Button/FormActionButtons";
import { jabatan, status, roles } from "mock/dummyOptions";

// helper: ubah string array ke format { id, label }
const toOptions = (array) =>
  array.map((label) => ({
    id: label.toLowerCase().replace(/\s+/g, "-"),
    label,
  }));

const EditAdmin = () => {
  const navigate = useNavigate();
  const [editIndex, setEditIndex] = useState(null);
  const [kodeKaryawan, setKodeKaryawan] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  // Gunakan dummy yang sudah diformat
  const jabatanOptions = toOptions(jabatan);
  const jenisPenggunaOptions = toOptions(roles);
  const statusKeanggotaanOptions = toOptions(status);

  useEffect(() => {
    const adminToEdit = JSON.parse(localStorage.getItem("editAdmin"));
    const allAdmins = JSON.parse(localStorage.getItem("admins")) || [];

    if (adminToEdit) {
      const index = allAdmins.findIndex((a) => a.email === adminToEdit.email);
      setEditIndex(index);

      setValue("nama", adminToEdit.nama || "");
      setValue("jabatan", adminToEdit.jabatan || "");
      setValue("jenis", adminToEdit.jenis || "");
      setValue("status", adminToEdit.status || "");
      setValue("telp", adminToEdit.telp || "");
      setValue("alamat", adminToEdit.alamat || "");
      setValue("tanggalMasuk", adminToEdit.tanggalMasuk || "");
      setValue("email", adminToEdit.email || "");
      setValue("password", adminToEdit.password || "");
      setKodeKaryawan(adminToEdit.kode || "");
    }
  }, [setValue]);

  const onSubmit = (data) => {
    const allAdmins = JSON.parse(localStorage.getItem("admins")) || [];

    const updatedAdmin = {
      ...data,
      kode: kodeKaryawan,
      role: "ADMIN",
    };

    allAdmins[editIndex] = updatedAdmin;

    localStorage.setItem("admins", JSON.stringify(allAdmins));
    localStorage.removeItem("editAdmin");
    navigate("/data-admin");
  };

  const handleCancel = () => {
    navigate("/data-admin");
  };

  return (
    <div className="pl-64 mt-8">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="max-w-4xl p-5 mx-auto bg-white border border-gray-200 shadow-lg rounded-2xl"
      >
        <h2 className="mb-5 text-lg font-semibold text-center text-green-700 sm:text-xl">
          Edit Data Admin
        </h2>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {/* Kolom Kiri */}
          <div className="space-y-4">
            <InputField
              label="Nama Lengkap"
              {...register("nama", { required: "Nama wajib diisi" })}
              error={errors.nama}
            />
            <InputField
              label="Email"
              name="email"
              type="email"
              {...register("email", {
                required: "Email wajib diisi",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Format email tidak valid",
                },
              })}
              error={errors.email}
            />

            <SelectField
              label="Jabatan"
              options={jabatanOptions}
              {...register("jabatan", { required: "Jabatan wajib diisi" })}
              error={errors.jabatan}
            />

            <SelectField
              label="Jenis Pengguna"
              options={jenisPenggunaOptions}
              {...register("jenis", { required: "Jenis wajib diisi" })}
              error={errors.jenis}
            />

            <TextAreaField
              label="Alamat"
              {...register("alamat", { required: "Alamat wajib diisi" })}
              error={errors.alamat}
            />
          </div>

          {/* Kolom Kanan */}
          <div className="space-y-4">
            <InputField
              label="No. Telp"
              {...register("telp", { required: "No. Telp wajib diisi" })}
              error={errors.telp}
            />
            <InputField
              label="Password"
              type="password"
              readOnly
              {...register("password")}
            />

            <SelectField
              label="Status Keanggotaan"
              options={statusKeanggotaanOptions}
              {...register("status", { required: "Status wajib diisi" })}
              error={errors.status}
            />

            <InputField label="Kode Karyawan" value={kodeKaryawan} readOnly />

            <DateField
              label="Tanggal Masuk"
              {...register("tanggalMasuk", {
                required: "Tanggal Masuk wajib diisi",
              })}
              error={errors.tanggalMasuk}
            />
          </div>
        </div>

        <FormActionButtons
          submitLabel="Simpan"
          cancelLabel="Batal"
          onCancel={handleCancel}
          fullWidth={true}
        />
      </form>
    </div>
  );
};

export default EditAdmin;
